import React, { useRef, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, CardMedia, TextField, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AudioPlayer from 'react-h5-audio-player';
import ReactPlayer from 'react-player';
import { MetadataSelectField } from './MetadataSelectField';
import { set } from 'react-hook-form';
import { GameCssStyles } from '../../GameManagement/GameCssStyles';
import { getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket';
import { checkAspectRatio, checkMediaRatio, getMediaDimensionsAndRatio, getSimplifiedAspectRatio } from '../../../utility/Common';
import { toast } from 'react-toastify';
import { setOnProgressCallback, uploadVideoToCloudflareStream } from '../../../network/cloudflare_stream_service/CloudflareStream_api_callback';
import ProgressModal from '../../../utility/ProgressModal';
import { uploadVideoToVimeo } from '../../../network/vimeo_network_service/Vimeo_api_callback';
import { VIMEO_BUCKETS } from '../../../network/vimeo_network_service/Vimeo_Constant';
import api_service from '../../../network/api_callbacks';


const MediaUploadDialog = ({ editableEntityData, open, onClose }) => {

    const mediaTypeOptions = [
        { _id: 'image', value: 'image', label: 'Image' },
        { _id: 'audio', value: 'audio', label: 'Audio' },
        { _id: 'video', value: 'video', label: 'Video' },
    ];

    const typeOptions = [
        { value: 'avatar', label: 'Avatar' },
        { value: 'thumbnail', label: 'Thumbnail' },
    ];

    const fileInputRef = useRef(null);
    const [mediaType, setMediaType] = useState(mediaTypeOptions[0]?.value);
    const [media, setMedia] = useState(null);

    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [loader, setLoader] = useState(false);

    const handleGameBannerChnageUploadImageBTClick = () => {
        fileInputRef.current.click();
    }

    const addMediaOnServer = async () => {
        let requestBody = null;
        //console.log("editableEntityData : ", editableEntityData);
        //console.log("media : ", media);
        if (media?.form === 'video') {
            requestBody = {
                ...media,
                entityId: editableEntityData?._id,
                entityType: editableEntityData?.type,
                newForm:'video'
            }
        }
        else {
            requestBody = {
                ...media,
                entityId: editableEntityData?._id,
                entityType: editableEntityData?.type,
            }
        }
        //console.log("addMediaOnServer : ", requestBody);
        try {
            setLoader(true);
            const response = await api_service.createMultiMedia(requestBody);
            setLoader(false);
            console.log('📘 Multimedia :', response);
            if (response?._id) {
                toast.success("Multimedia added successfully.");
                setMedia(null);
                setMediaType(mediaTypeOptions[0]?.value);
                onClose();
            }
        } catch (error) {
            setLoader(false);
            console.error('❌ Failed to fetch Multimedia:', error);
        }
    }

    const handleGameBannerFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            const mimeType = file.type;
            var type = "unknown";
            if (mimeType.startsWith(`${mediaType}/`)) {
                type = mediaType;
            }
            if (mediaType === "image") {
                const result = await uploadFileToAWSS3Bucket("banners", file);
                console.log("result : ", result)
                const fileResult = await getSingleFileByNameFromAWSS3Bucket("banners", result?.key?.split('/').pop());
                console.log("fileResult : ", fileResult)
                //const mediaInfo = await checkMediaRatio(fileResult?.url?.href, mediaType);
                const mediaInfo = await checkMediaRatio(fileResult, mediaType);
                console.log("mediaInfo : ", mediaInfo)
                if (mediaInfo?.matched) {

                    setMedia({ ...media, form: mediaType, url: fileResult, aspectRatio: mediaInfo?.ratio });
                }
                else {
                    toast.error(`Please select ${mediaType} in mentioned aspect ratio only 1:1 & 16:9`);
                    setMedia({ ...media, form: mediaType, url: '', aspectRatio: '' });
                }
            }
            else if (mediaType === "video") {
                try {
                    setUploading(true);
                    setProgress(0);
                    setOnProgressCallback((percent) => setProgress(percent));
                    const { width, height, mediaType, ratio } = await getMediaDimensionsAndRatio(file);
                    const mediaInfo = await checkMediaRatio(file, mediaType);
                    const resp = await uploadVideoToCloudflareStream(file);
                    const finalUrl = resp?.videoUrl;
                    console.log("Cloudflare Stream upload:", finalUrl);
                    console.log("mediaInfo : ", mediaInfo)
                    const videoObj = {
                        mediaType: "video",
                        url: `${finalUrl}`,
                        aspectRatio: `${ratio}`
                    }
                    //const newMultimedia = Array.isArray(editableEntityData?.multimedia) ? [...editableEntityData.multimedia] : [];
                    //newMultimedia.push(videoObj);
                    //updateStateObjectData(editableEntityData, setEditableEntityData, "multimedia", newMultimedia)
                    setMedia({ ...media, form: mediaType, url: finalUrl, aspectRatio: ratio });
                    //e.target.value = null; // reset input
                } catch (err) {
                    console.error("Upload failed:", err);
                    toast.error(err?.message || `Upload failed for ${file?.name || "file"}`);
                    setMedia({ ...media, form: mediaType, url: '', aspectRatio: '' });
                }
                finally {
                    setUploading(false);
                    setProgress(0);
                }
            }
            else if (mediaType === "audio") {
                try {
                    setUploading(true);
                    setProgress(0);
                    setOnProgressCallback((percent) => setProgress(percent));
                    const resp = await uploadVideoToVimeo(file, VIMEO_BUCKETS.VIMEO_BUCKET_ENTITY_VIDEOS_STAGING, mediaType);
                    console.log("VIMEO 1 : ", resp)
                    const lastSegment = resp?.videoUri;
                    const finalUrl = "https://api.vimeo.com" + lastSegment;
                    console.log("VIMEO 3 : ", finalUrl)
                    const videoObj = {
                        mediaType: "audio",
                        url: `${finalUrl}`,
                    }
                    //const newMultimedia = Array.isArray(editableEntityData?.multimedia) ? [...editableEntityData.multimedia] : [];
                    //newMultimedia.push(videoObj);
                    //updateStateObjectData(editableEntityData, setEditableEntityData, "multimedia", newMultimedia)
                    setMedia({ ...media, form: mediaType, url: finalUrl });
                    //e.target.value = null; // reset input
                } catch (err) {
                    console.error("Upload failed:", err);
                    setMedia({ ...media, form: mediaType, url: '', });
                }
                finally {
                    setUploading(false);
                    setProgress(0);
                }
            }
            else {
                console.error("Unsupported file type selected. Please select a valid file.");
                toast.error("Unsupported file type selected. Please select a valid file.");
                setMedia({ ...media, form: mediaType, url: '' });
            }
        }
        else {
            console.error("No file selected");
            setMedia({ ...media, form: mediaType, url: '' });
        }
    }


    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                Upload MultiMedia
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <MetadataSelectField
                    label="Media Type"
                    value={mediaType}
                    onChange={(value) => {
                        console.log("value : ", value);
                        setMediaType(value)
                        setMedia({ ...media, form: value, url: '' });
                    }}
                    options={mediaTypeOptions}
                />

                <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={2} mt={2} alignItems={"center"} justifyContent={"center"}>
                    <TextField
                        fullWidth
                        label="Multimedia URL"
                        multiline={false}
                        rows={1}
                        value={media?.url || ''}
                        onChange={(e) => {
                            console.log("e.target.value : ", e.target.value);
                            //setMedia({ ...media, form: e.target.value });
                        }}
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />

                    <Typography variant="h6" fontWeight={400} mb={0} alignSelf={"center"} justifySelf={'center'}>or</Typography>

                    <>
                        <input
                            type="file"
                            accept={`${mediaType}/*`}
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleGameBannerFileChange}
                        />
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{ height: "100%" }}
                            onClick={() => {
                                handleGameBannerChnageUploadImageBTClick()
                            }}
                        >
                            {"Upload"}
                        </Button>
                    </>
                </Box>

                {media?.aspectRatio && <Typography variant="h6" fontWeight={600} alignSelf={"flex-start"} justifySelf={"flex-start"} mt={1} color={'success'}>Ratio - {media?.aspectRatio}</Typography>}
                {(mediaType === 'image' || mediaType === 'video') && <Typography variant="h6" fontWeight={400} mb={2} alignSelf={"flex-start"} justifySelf={"flex-start"} mt={1}>select multimedia in mentioned aspect ratio only 1:1 & 16:9</Typography>}

                {(mediaType === 'image') && <MetadataSelectField
                    label="Type"
                    value={media?.type || ''}
                    onChange={(value) => {
                        console.log("value : ", value);
                        setMedia({ ...media, type: value });
                    }}
                    options={typeOptions}
                />}

                <Button
                    variant="contained"
                    color="secondary"
                    sx={{ width: "100%", height: "100%", mt: 4 }}
                    onClick={() => {
                        addMediaOnServer();
                    }}
                >
                    {"Submit"}
                </Button>

                {/* {multimedia?.mediaType === 'image' && (
          <CardMedia
            component="img"
            image={multimedia?.url}
            alt="Preview Image"
            sx={{ width: '100%', maxHeight: 400, objectFit: 'contain' }}
          />
        )}
        {multimedia?.mediaType === 'audio' && (
          <AudioPlayer
            src={multimedia?.url}
            layout="horizontal"
            showJumpControls={false}
            showDownloadProgress={false}
            customAdditionalControls={[]}
            customVolumeControls={[]}
            style={{ marginTop: 10 }}
          />
        )}
        {multimedia?.mediaType === 'video' && (
          <Box sx={{ mt: 2 }}>
            {multimedia?.url?.includes("vimeo.com") ? (
              <iframe
                src={`https://player.vimeo.com/video/${multimedia?.url?.split("/").pop()}`}
                width="100%"
                height="300px"
                style={{ border: 0 }}
                allow="autoplay; fullscreen; picture-in-picture"
                frameBorder="0"
                //allow="fullscreen"
                allowFullScreen={false}></iframe>) :
              (<ReactPlayer
                url={multimedia?.url}
                controls
                width="100%"
                height="300px"
              />)
            }
          </Box>
        )} */}

                {(uploading || loader) && <ProgressModal open={uploading || loader} isLoader={loader} progress={progress} title="Uploading File" />}
            </DialogContent>
        </Dialog>
    );
}

export default MediaUploadDialog;